export default __webpack_public_path__ + "static/media/ambasador_thumb.4f179c56.jpg";